<template>
    <div id="home">
        <!-- <div id="content" class="split"><HelloWorld msg="Welcome to Your Vue.js App" />></div>
        <div id="splash" class="split"> -->
        <!-- <img alt="Nicol Bolas" src="../assets/img/cardart-full-maelstrom-wanderer.jpg" /> -->
        <!-- </div> -->
        <img src="../assets/img/planeswalker.png" />
    </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue';

export default {
    name: 'HomeView',
    components: {
        HelloWorld,
    },
};
</script>

<style lang="scss">
#home {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: center;
    height: 100%;
    gap: 1rem;

    img {
        height: 90%;
        margin: auto;
    }

    .split {
        height: 100%;
        flex: 1;
    }

    #splash {
        // img {
        //     position: fixed;
        //     right: 0;
        //     bottom: 0;
        //     // height: 100%;
        // }

        background-image: linear-gradient(to left, rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 1)),
            url('../assets/img/cardart-full-maelstrom-wanderer.jpg');
        background-position: bottom 0 right 0;
        // width: 80%;
        // height: 200px;
        background-size: cover;
        color: white;
    }
}
</style>
